<template>
    <div class="l-ma mx-auto max-w-[600px] text-[#1D1D1B]" v-if="isThemeReady">
      <Header />
      <main class="l-bd relative z-[1] pb-[76px] pt-[74px]">
        <router-view />
      </main>
      <Footer />
      <ModalBox v-model:open="commonStore.errorServer.open" width="w-[315px]">
        <div class="bg-[#F4F1E7] px-[25px] py-[30px] text-center">
          <p
            class="mb-[14px] text-[20px] tracking-[0.3em]"
            v-if="commonStore.errorServer.title"
          >
            {{ commonStore.errorServer.title }}
          </p>
          <p class="text-[14px]" v-if="commonStore.errorServer.message">
            {{ commonStore.errorServer.message }}
          </p>
          <div class="mt-[40px] text-center">
            <button
              type="button"
              class="inline-flex w-[160px] items-center justify-center bg-black p-[10px] text-center text-white shadow-btn"
              @click="() => (commonStore.errorServer.open = false)"
            >
              <p class="text-[16px]">確認</p>
            </button>
          </div>
        </div>
      </ModalBox>
    </div>
    <div
      v-if="commonStore.loading"
      class="m-loading fixed inset-0 z-[10] inline-flex items-center justify-center"
    >
      <i class="absolute inset-0 bg-[var(--bg-body)]"></i>
      <div class="absolute z-[1]">
        <figure v-if="config?.loading?.iconUrl">
          <img
            :src="config.loading.iconUrl"
            class="h-[110px] w-[110px]"
            :alt="config.title"
          />
        </figure>
        <p class="text-center text-[14px] tracking-[0.4em] text-[#1D1D1B]">
          Loading<span class="m-loading-dot">.</span>
        </p>
      </div>
    </div>
    <div id="Modal"></div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useCommonStore } from '@/store/common'

import Header from './components/Layout/Header.vue'
import Footer from './components/Layout/Footer.vue'

import { useLayoutConfig } from '@/composables/useLayoutConfig'

const route = useRoute()
const { config, setTheme } = useLayoutConfig()

const commonStore = useCommonStore()

const isThemeReady = ref(false)

const brand = computed(() => route.params.brand)

watch(
  brand,
  (value) => {
    if (!value) return
    setTheme(value)

    isThemeReady.value = true
  },
  { immediate: true }
)

</script>

<style lang="postcss">
.l-bd {
  min-height: calc(100vh-114px-75px);
}

@keyframes circle-spin {
  50% {
    stroke-dasharray: 231.3274122872, 20;
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dasharray: 20, 231.3274122872;
    stroke-dashoffset: -251.3274122872;
  }
}

@keyframes wrapper-spin {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.m-loading-dot {
  &:before,
  &:after {
    content: '.';
  }

  & {
    animation: fade 1s linear infinite;
  }

  &:after {
    animation: fade 2s linear infinite;
  }
}


.dalmore {
  --bg-body: #f4f1e7;
  --color-body: #000000;

  --gradient-primary: linear-gradient(140deg, #9a774f 10%, #000000 100%);
  --color-button-primary: #B5844D;
  --color-accent: #000000;
  --color-primary: #B5844D;
  --color-error: #B80000;
  --bg-header: #FFF8E6;
}
.jura {
  --bg-body: #F8F7F9;
  --color-body: #000000;
  
  --gradient-primary: linear-gradient(140deg, #9243A9 10%, #61366E 100%);
  --color-button-primary: #61366E;
  --color-accent: #61366E;
  --color-primary: #61366E;
  --color-error: #B80000;
  --bg-header: #61366E;
}
.fettercairn {
  --bg-body: #F8F7F9;
  --color-body: #000000;
  
  --gradient-primary: #00AAA1;
  --color-button-primary: #00AAA1;
  --color-accent: #00AAA1;
  --color-primary: #00AAA1;
  --color-error: #B80000;
  --bg-header: #00AAA1;

  .l-ma {
    position: relative;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        to bottom,
        #F2F8F8 70%,
        #B2E6E2 100%
      );
      background-size: cover;
      background-position: center;
      z-index: -1;
    }
  }
}
.tamnavulin {
  --bg-body: #F6F1EA;
  --color-body: #000000;
  
  --gradient-primary: #A48242;
  --color-button-primary: #A48242;
  --color-accent: #A48242;
  --color-primary: #A48242;
  --color-error: #B80000;
  --bg-header:#3E3127;
}
</style>
